



















import {Component, Vue} from "vue-property-decorator";
import HoverLinkCard from "@/components/infrastructures/atoms/HoverLinkCard.vue";
import {User} from "@/components/domains/authorization/user";
import {AuthGetterTypes} from "@/store/auth/types";
import {needsMailAddressSetup} from "@/components/domains/account/passwordless/authPolicy";
import {loadAuthPolicy} from "@/components/domains/account/passwordless/passwordlessService";

@Component({
  components: {HoverLinkCard}
})
export default class Settings extends Vue {
  name = "Settings";
  user: User = this.$store.getters[AuthGetterTypes.getCurrentUser];

  // /auth/policy が取れないとき・取れるまでは、これまでどおり表示する
  easilyLoginAllowed = true;
  showMailAddressSetup = false;

  mounted() {
    loadAuthPolicy({fresh: true}).then((policy) => {
      this.easilyLoginAllowed = policy.easilyLoginAllowed;
      this.showMailAddressSetup = needsMailAddressSetup(policy, this.$store.getters[AuthGetterTypes.getCurrentUser]);
    });
  }
}
